import { gql } from "@/__generated__/gql";

export const ORG_PERMISSIONS = gql(`
query orgFeatureFlags($id: ID!) {
    node(id: $id) {
      id
      ... on Organization {
        id
        permissions {
          flags
          partnershipLevel
        }
      }
    }
  }
`);
